<template>
  <div>
    <div
      style="
        border: 1px solid #d1d5db;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
        border-radius: 5px;
      "
      class="rounded-md group animate-pulse"
    >
      <div class="flex p-5">
        <div class="shrink-0">
          <div
            class="w-20 h-20 rounded-full bg-neutral-200"
            style="box-shadow: 0px 0px 0px 2px #ffffff"
          />
        </div>
        <div class="flex flex-col flex-1 px-6 my-auto">
          <div class="h-4 bg-neutral-200 rounded w-full" />
          <div class="mt-2 h-4 bg-neutral-200 rounded w-10/12" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterSkeletonTile',
};
</script>
